var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: "Document permissions" },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _vm.isLoading
              ? _c("ProjectDocumentAccessScopePlaceholder")
              : _c("div", [
                  _c(
                    "div",
                    { staticClass: "flex items-center mb-2" },
                    [
                      _c("DocumentExtensionIcon", {
                        staticClass: "mr-2",
                        attrs: { extension: _vm.documentExtension },
                      }),
                      _c("p", { staticClass: "flex flex-wrap" }, [
                        _c("span", { staticClass: "font-semibold mr-1" }, [
                          _vm._v(" " + _vm._s(_vm.fileName) + " "),
                        ]),
                        _c("span", [
                          _vm._v(" is available for the following users: "),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "px-10" },
                    [
                      _vm.isUploadedByAdmin
                        ? _c("DefaultRadioButton", {
                            class: _vm.radioButtonClasses,
                            attrs: {
                              label: "Available for Admin only",
                              name: _vm.radioButtonGroupName,
                              value: _vm.DocumentProjectAccessScope.ADMIN,
                              checked: _vm.isChecked(
                                _vm.DocumentProjectAccessScope.ADMIN
                              ),
                            },
                            on: {
                              input: (accessScope) =>
                                (_vm.chosenAccessScope = accessScope),
                            },
                          })
                        : _vm._e(),
                      _c("DefaultRadioButton", {
                        class: _vm.radioButtonClasses,
                        attrs: {
                          label:
                            "Available for Admin and current project Manager only",
                          value: _vm.DocumentProjectAccessScope.MANAGEMENT,
                          name: _vm.radioButtonGroupName,
                          checked: _vm.isChecked(
                            _vm.DocumentProjectAccessScope.MANAGEMENT
                          ),
                        },
                        on: {
                          input: (accessScope) =>
                            (_vm.chosenAccessScope = accessScope),
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("DefaultRadioButton", {
                            staticClass: "mr-2",
                            class: _vm.radioButtonClasses,
                            attrs: {
                              label: "Available to everyone in this project",
                              name: _vm.radioButtonGroupName,
                              value: _vm.DocumentProjectAccessScope.ALL,
                              checked: _vm.isChecked(
                                _vm.DocumentProjectAccessScope.ALL
                              ),
                            },
                            on: {
                              input: (accessScope) =>
                                (_vm.chosenAccessScope = accessScope),
                            },
                          }),
                          _c(
                            "Tooltip",
                            {
                              staticClass: "flex items-center",
                              attrs: {
                                variant: _vm.TooltipVariants.DARK,
                                title:
                                  "Available for Admin, Manager and any contractor with an task within this project",
                                tooltipClasses: "w-56",
                                placement: "right",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex justify-center items-center w-5 h-5 font-secondary text-primary border-1 border-primary rounded-full hover:text-primary-600 hover:border-primary-600 cursor-default",
                                },
                                [_vm._v(" ? ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("DefaultRadioButton", {
                        class: _vm.radioButtonClasses,
                        attrs: {
                          label:
                            "Available for Admin, project Manager and the following Contractors:",
                          name: _vm.radioButtonGroupName,
                          value: _vm.DocumentProjectAccessScope.SELECTED,
                          checked: _vm.isChecked(
                            _vm.DocumentProjectAccessScope.SELECTED
                          ),
                        },
                        on: {
                          input: (accessScope) =>
                            (_vm.chosenAccessScope = accessScope),
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "flex mb-5 px-6" },
                        [
                          _c("ValidatableEmployeesMultiselect", {
                            attrs: {
                              error: "Select at least one contractor",
                              multiselectClasses: "min-w-68",
                              outerError: _vm.contractorSelectError,
                              contractorsConditions: _vm.contractorsConditions,
                              disabled: _vm.contractorsMultiselectDisabled,
                            },
                            model: {
                              value: _vm.selectedContractorsIds,
                              callback: function ($$v) {
                                _vm.selectedContractorsIds = $$v
                              },
                              expression: "selectedContractorsIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("ModalSectionsDivider"),
            _c(
              "div",
              { staticClass: "flex pt-5" },
              [
                _c("UiButton", {
                  staticClass: "mr-4",
                  attrs: { buttonText: "Cancel", variant: "outline" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                }),
                _c("UiButton", {
                  attrs: {
                    buttonText: "Change",
                    disabled: false,
                    processing: _vm.processing,
                  },
                  on: { click: _vm.updateAccessScope },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }